import React from "react";
import { motion } from "framer-motion";
import classes from "./Loading.module.scss";
function Loading() {
  const svgVariants = {
    hidden: { rotate: 0 },
    visible: {
      rotate: 0,
      transition: { duration: 1 },
    },
  };

  const pathVariants = {
    hidden: {
      opacity: 1,
      fill: "#A52A2A",
      pathLength: 0,
    },
    visible: {
      opacity: 1,
      fill: "#e3b8ae",
      pathLength: 1,
      transition: {
        duration: 3,
        ease: "easeInOut",
        fill: {
          delay: 1.5,
          duration: 1.5,
        },
      },
    },
  };

  return (
    <motion.div
      animate={{ y: -3000 }}
      transition={{ delay: 3, duration: 1.5 }}
      className={classes.loading}
    >
      <div>
        <motion.svg
          className={classes.svg}
          viewBox="-5 -5 250 250"
          xmlns="http://www.w3.org/2000/svg"
          variants={svgVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.path
            d="M 0.001 150.601 L 27.901 150.601 A 50.464 50.464 0 0 0 29.256 162.629 A 34.936 34.936 0 0 0 37.951 178.801 Q 48.001 189.301 64.501 189.301 L 97.801 189.301 A 62.998 62.998 0 0 0 108.365 188.468 Q 114.202 187.474 118.929 185.294 A 32.597 32.597 0 0 0 124.201 182.251 A 24.737 24.737 0 0 0 130.519 175.895 Q 134.045 170.623 134.1 163.721 A 27.496 27.496 0 0 0 134.101 163.501 L 134.101 147.301 A 19.958 19.958 0 0 0 127.905 132.501 A 24.981 24.981 0 0 0 127.051 131.701 A 29.822 29.822 0 0 0 119.233 126.752 Q 115.638 125.152 111.252 124.121 A 60.923 60.923 0 0 0 107.101 123.301 L 52.501 114.301 A 93.902 93.902 0 0 1 37.295 110.592 Q 24.015 106.07 15.451 97.801 A 41.793 41.793 0 0 1 2.414 67.476 A 53.904 53.904 0 0 1 2.401 66.301 L 2.401 49.801 Q 2.401 27.301 19.651 13.651 A 60.402 60.402 0 0 1 42.522 2.614 Q 51.323 0.369 61.673 0.053 A 112.434 112.434 0 0 1 65.101 0.001 L 99.001 0.001 Q 116.701 0.001 130.351 7.351 Q 144.001 14.701 151.501 28.051 A 58.479 58.479 0 0 1 158.472 49.843 A 73.916 73.916 0 0 1 159.001 58.801 L 130.801 58.801 A 41.999 41.999 0 0 0 129.526 48.174 A 30.412 30.412 0 0 0 122.101 34.651 A 28.959 28.959 0 0 0 104.409 25.85 A 40.553 40.553 0 0 0 99.001 25.501 L 65.101 25.501 A 56.689 56.689 0 0 0 54.86 26.373 Q 48.915 27.466 44.157 29.928 A 31.241 31.241 0 0 0 40.351 32.251 A 22.664 22.664 0 0 0 33.727 39.385 Q 31.166 43.842 30.926 49.515 A 28.06 28.06 0 0 0 30.901 50.701 L 30.901 64.201 Q 30.901 73.801 37.651 80.101 A 29.242 29.242 0 0 0 44.969 85.01 Q 50.11 87.489 57.001 88.801 L 111.001 98.101 Q 129.263 101.182 141.312 108.538 A 52.035 52.035 0 0 1 149.251 114.451 A 39.234 39.234 0 0 1 162.561 142.918 A 48.834 48.834 0 0 1 162.601 144.901 L 162.601 164.401 A 47.784 47.784 0 0 1 159.121 182.923 Q 154.803 193.306 145.127 200.941 A 55.476 55.476 0 0 1 145.051 201.001 A 61.27 61.27 0 0 1 122.402 211.968 Q 111.587 214.801 98.401 214.801 L 63.901 214.801 A 78.886 78.886 0 0 1 43.721 212.354 A 57.114 57.114 0 0 1 17.401 197.401 A 58.072 58.072 0 0 1 1.455 166.595 A 83.945 83.945 0 0 1 0.001 150.601 Z"
            vector-effect="non-scaling-stroke"
            variants={pathVariants}
          />
        </motion.svg>
        <motion.svg
          className={classes.svg}
          variants={svgVariants}
          initial="hidden"
          animate="visible"
          viewBox="-5 -5 250 250"
          xmlns="http://www.w3.org/2000/svg"
        >
          <motion.path
            variants={pathVariants}
            d="M 0.001 150.601 L 27.901 150.601 A 50.464 50.464 0 0 0 29.256 162.629 A 34.936 34.936 0 0 0 37.951 178.801 Q 48.001 189.301 64.501 189.301 L 97.801 189.301 A 62.998 62.998 0 0 0 108.365 188.468 Q 114.202 187.474 118.929 185.294 A 32.597 32.597 0 0 0 124.201 182.251 A 24.737 24.737 0 0 0 130.519 175.895 Q 134.045 170.623 134.1 163.721 A 27.496 27.496 0 0 0 134.101 163.501 L 134.101 147.301 A 19.958 19.958 0 0 0 127.905 132.501 A 24.981 24.981 0 0 0 127.051 131.701 A 29.822 29.822 0 0 0 119.233 126.752 Q 115.638 125.152 111.252 124.121 A 60.923 60.923 0 0 0 107.101 123.301 L 52.501 114.301 A 93.902 93.902 0 0 1 37.295 110.592 Q 24.015 106.07 15.451 97.801 A 41.793 41.793 0 0 1 2.414 67.476 A 53.904 53.904 0 0 1 2.401 66.301 L 2.401 49.801 Q 2.401 27.301 19.651 13.651 A 60.402 60.402 0 0 1 42.522 2.614 Q 51.323 0.369 61.673 0.053 A 112.434 112.434 0 0 1 65.101 0.001 L 99.001 0.001 Q 116.701 0.001 130.351 7.351 Q 144.001 14.701 151.501 28.051 A 58.479 58.479 0 0 1 158.472 49.843 A 73.916 73.916 0 0 1 159.001 58.801 L 130.801 58.801 A 41.999 41.999 0 0 0 129.526 48.174 A 30.412 30.412 0 0 0 122.101 34.651 A 28.959 28.959 0 0 0 104.409 25.85 A 40.553 40.553 0 0 0 99.001 25.501 L 65.101 25.501 A 56.689 56.689 0 0 0 54.86 26.373 Q 48.915 27.466 44.157 29.928 A 31.241 31.241 0 0 0 40.351 32.251 A 22.664 22.664 0 0 0 33.727 39.385 Q 31.166 43.842 30.926 49.515 A 28.06 28.06 0 0 0 30.901 50.701 L 30.901 64.201 Q 30.901 73.801 37.651 80.101 A 29.242 29.242 0 0 0 44.969 85.01 Q 50.11 87.489 57.001 88.801 L 111.001 98.101 Q 129.263 101.182 141.312 108.538 A 52.035 52.035 0 0 1 149.251 114.451 A 39.234 39.234 0 0 1 162.561 142.918 A 48.834 48.834 0 0 1 162.601 144.901 L 162.601 164.401 A 47.784 47.784 0 0 1 159.121 182.923 Q 154.803 193.306 145.127 200.941 A 55.476 55.476 0 0 1 145.051 201.001 A 61.27 61.27 0 0 1 122.402 211.968 Q 111.587 214.801 98.401 214.801 L 63.901 214.801 A 78.886 78.886 0 0 1 43.721 212.354 A 57.114 57.114 0 0 1 17.401 197.401 A 58.072 58.072 0 0 1 1.455 166.595 A 83.945 83.945 0 0 1 0.001 150.601 Z"
            vector-effect="non-scaling-stroke"
          />
        </motion.svg>
      </div>
    </motion.div>
  );
}

export default Loading;
